import React from 'react';

const ML_JavaScript = () => {
    return (
        <div>ML_JavaScript Component</div>
    );
}

export default ML_JavaScript;
